import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import SignIn from 'pages/auth/pages/Login/Login';
import { LOGIN_ROUTES } from 'pages/auth/constants';
import { isRenderedAsIframeInNewUI } from 'config';

const ForgotForm = lazy(() => import(/* webpackPrefetch: true */ 'pages/auth/pages/ForgotPassword/ForgotPassword'));
const MfaAuth = lazy(() => import(/* webpackPrefetch: true */ 'pages/auth/pages/MfaAuth/MfaAuth'));
const MfaQR = lazy(() => import(/* webpackPrefetch: true */ 'pages/auth/pages/MfaQR/MfaQR'));
const ResetPassword = lazy(() => import(/* webpackPrefetch: true */ 'pages/auth/pages/ResetPassword/ResetPassword'));
const PasswordExpired = lazy(
  () => import(/* webpackPrefetch: true */ 'pages/auth/pages/PasswordExpired/PasswordExpired')
);
const Register = lazy(() => import(/* webpackPrefetch: true */ 'pages/auth/pages/Register/Register'));
const LoginWithCookie = lazy(
  () => import(/* webpackPrefetch: true */ 'pages/auth/pages/LoginWithCookie/LoginWithCookie')
);

const routes = isRenderedAsIframeInNewUI ? (
  <></>
) : (
  <>
    <Route path={LOGIN_ROUTES.LOGIN} element={<SignIn />} />
    <Route path={LOGIN_ROUTES.FORGOT_PASSWORD} element={<ForgotForm />} />
    <Route path={LOGIN_ROUTES.PHONE_VERIFICATION} element={<MfaAuth />} />
    <Route path={LOGIN_ROUTES.QR_VERIFICATION} element={<MfaQR />} />
    <Route path={LOGIN_ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
    <Route path={LOGIN_ROUTES.PASSWORD_EXPIRED} element={<PasswordExpired />} />
    <Route path={LOGIN_ROUTES.REGISTER} element={<Register />} />
    <Route path={LOGIN_ROUTES.LOGIN_WITH_COOKIE} element={<LoginWithCookie />} />
  </>
);

export default routes;
